<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    :title="$t('views.invoices_view.invoices')"
    color="rgb(0, 168, 215)"
    icon="list"
  >
    <invoices-table :planIdentityId="$router.currentRoute.params.planId"></invoices-table>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import InvoicesTable from "@/components/Invoices/InvoicesTable";
import { planSetter } from "@/mixins/planSetter";
import { mapGetters } from "vuex";

export default {
  components: { InvoicesTable },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  data: () => ({
  }),
  
};
</script>
